// Import icons
import icon1 from "../../images/preview/icon/elementor.svg";
import icon2 from "../../images/preview/icon/elementor-pro.svg";
import icon3 from "../../images/preview/icon/woocommerce.png";
import icon4 from "../../images/preview/icon/revolution.png";
import icon5 from "../../images/preview/icon/yoast-logo.svg";
import icon6 from "../../images/preview/icon/loco.png";
import icon7 from "../../images/preview/icon/really-simple.png";
import icon8 from "../../images/preview/icon/wordfence.svg";
import icon9 from "../../images/preview/icon/udp-logo.svg";
import icon10 from "../../images/preview/icon/cache.png";
import icon11 from "../../images/preview/icon/cf7-logo.svg";
import icon12 from "../../images/preview/icon/mc4wp.png";

// Title icon
import titleIcon from "../../images/preview/title-2.png";

// Features list
const features = [
  { img: icon1, title: "Elementor Page Builder" },
  { img: icon2, title: "Elementor PRO" },
  { img: icon3, title: "WooCommerce" },
  { img: icon4, title: "Slider Revolution" },
  { img: icon5, title: "Yoast SEO" },
  { img: icon6, title: "Loco Translate" },
  { img: icon7, title: "Really Simple SSL" },
  { img: icon8, title: "Wordfence Security Firewall & Malware" },
  { img: icon9, title: "Lifetime Update" },
  { img: icon10, title: "WP Super Cache" },
  { img: icon11, title: "Contact Form 7" },
  { img: icon12, title: "MC4WP" },
];

const AwesomeFeatures = () => {
  return (
    <section className="wpo-awesome-features-section section-padding">
      <div className="container">

        {/* Section Title */}
        <div className="row justify-content-center">
          <div className="col col-lg-5">
            <div className="preview-section-title">
              <i>
                <img src={titleIcon} alt="Section Decoration" />
              </i>
              <h2>Compatible plugins</h2>
              <p>
                This is a vast collection of plugins compatible with Bohu.
                We make sure that you can build rich Wedding & Planner
                Design sites.
              </p>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="wpo-awesome-features-wrapper">
          <div className="row">
            {features.map((item, index) => (
              <div
                key={index}
                className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12"
              >
                <div className="wpo-awesome-features-item">
                  <div className="wpo-awesome-features-icon">
                    <i>
                      <img src={item.img} alt={item.title} />
                    </i>
                  </div>
                  <div className="wpo-awesome-features-text">
                    <h2>{item.title}</h2>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default AwesomeFeatures;
